import React, {Component} from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation, Query} from 'react-apollo'
import moment from 'moment'
import {toast} from 'react-toastify'

import AnnualLeaveInput from './AnnualLeaveInput'
import AnnualLeaveListContainer from './AnnualLeaveListContainer'

import query from '../../../queries/server/my_annual_leave'
import createAnnualLeaveMutation from '../../../queries/server/mutations/create_annual_leave'
import updateAnnualLeaveMutation from '../../../queries/server/mutations/update_annual_leave'
import annualLeaveRecordQuery from '../../../queries/server/annual_leave_record'
import annualLeaveEditLocalQuery from '../../../queries/client_side/mutations/edit_annual_leave'

export default class AnnualLeave extends Component {

  state = {
    showInput: false,
    showEdit: false,
    editAnnualLeaveID: null,
    start_date: '', 
    start_of_day: 1, 
    end_date: '', 
    end_of_day: 1,
    selectedUsers: [],
    whoFor: 1,
    errors: {},
  }

  toggle = () => {
    if (this.state.showInput) {
      this.resetData()
    }
    this.setState({showInput: !this.state.showInput})
  }

  toggleEdit = () => {
    this.setState({showEdit: !this.state.showEdit})
  }

  onChange = ({key, value}) => {
    console.log('kv', key, value)
    this.setState({[key]: value})
  }

  onUsersAdded = (users) => {
    const {selectedUsers} = this.state
    const newData = new Set([...selectedUsers, ...users])
    this.setState({selectedUsers: [...newData]})
  }

  onUsersRemoved = (users) => {
    const {selectedUsers} = this.state
    const newUsers = selectedUsers.reduce((carry, user_id) => {
      if (!users.includes(user_id)){
        carry.push(user_id)
      }
      return carry
    }, [])
    this.setState({selectedUsers: newUsers})
  }

  reset = () => {
    this.resetData()
    this.setState({
      showInput: false, 
    })
  }

  resetData = () => {
    this.setState({
      start_date: '', 
      start_of_day: '1', 
      end_date: '', 
      end_of_day: '1',
      selectedUsers: [],
      whoFor: 1,
      errors: {}
    })
  }

  resetEdit = () => {
    this.setState({showEdit: false, editAnnualLeaveID: null})
  }

  render(){

    const {toggle, onChange, reset, toggleEdit, resetEdit} = this
    const {showInput, showEdit, editAnnualLeaveID, selectedUsers, errors} = this.state

    return (
      <Mutation 
        mutation={createAnnualLeaveMutation}
        update={(cache, {data: {createAnnualLeave}}) => {
          if (createAnnualLeave.user.user_id === this.props.user_id) {
            const original = cache.readQuery({query})
            cache.writeQuery({
                query,
                data: {
                  me: {
                    ...original.me,
                    annual_leave: [
                      createAnnualLeave,
                      ...original.me.annual_leave
                    ]
                  }
                }
            })
          }
        }}
      >
        {(upsertAnnualLeaveFunc, {loading}) => (
          <div>
            <div className="d-flex flex-column pt-3 pl-3 pb-1 pr-3">
              <div className="d-flex justify-content-between flex-row align-items-center">
                <h1>Annual Leave</h1>
                <Button
                  size="sm"
                  color={showInput ? 'warning' : 'success'}
                  onClick={toggle}
                >
                    <FontAwesomeIcon color="#fff"
                                      icon={showInput ? 'minus' : 'plus'}/>{' '}
                    {showInput ? 'Cancel' : 'Request Annual Leave'}
                </Button>
              </div>
            </div>

            <AnnualLeaveListContainer
              onEdit={({id}) => {
                this.setState({editAnnualLeaveID: id})
                toggleEdit()
              }}
            />

            <AnnualLeaveInput 
              title="Request Annual Leave"
              isOpen={showInput}
              toggle={toggle}
              onChange={onChange}
              onUsersAdded={this.onUsersAdded}
              onUsersRemoved={this.onUsersRemoved}
              selectedUsers={this.state.selectedUsers}
              saving={loading}
              onSave={({start_date, start_of_day, end_date, end_of_day}) => {
                if (this.state.whoFor == 0) {

                  if (this.state.selectedUsers.length === 0) {
                    toast.error('Please select at least one member of staff', {autoClose: false})
                  } else {
                    const proms = selectedUsers.map(user_id => {
                      return upsertAnnualLeaveFunc({
                        variables: {
                          data: {
                            user_id,
                            start_date,
                            start_of_day: !!parseInt(start_of_day),
                            end_date,
                            end_of_day: !!parseInt(end_of_day)
                          }
                        }
                      })
                        .catch(e => {
                          e.data = {[user_id]: e.message}
                          throw e
                        })
                    })
  
                    Promise.allSettled(proms)
                      .then((results) => {
                        if (!results.some(({status}) => status === 'rejected')) {
                          toast.success('Annual Leave Requested', {autoClose: 2000})
                          reset()
                        } else {
                          const errors = results.reduce((carry, {status, reason}) => {
                            if (status === 'rejected') {
                              carry = {...carry, ...reason.data}
                            }
                            return carry
                          }, {})
                          this.setState({errors})
                        }
                      })
                  }
                } else {
                  return upsertAnnualLeaveFunc({
                    variables: {
                      data: {
                        start_date,
                        start_of_day: !!parseInt(start_of_day),
                        end_date,
                        end_of_day: !!parseInt(end_of_day)
                      }
                    }
                  })
                    .then(() => {
                      toast.success('Annual Leave Requested', {autoClose: 2000})
                      reset()
                    })
                    .catch(e => toast.error(e.message, {autoClose: false}))
                }
              }}
              {...this.state}
              errors={errors}
            />

            {editAnnualLeaveID && 
              <Mutation mutation={annualLeaveEditLocalQuery}>
                {(localMutationFunc, localMut) => (
                  <Mutation 
                    mutation={updateAnnualLeaveMutation}
                    update={(cache, {data: {updateAnnualLeave}}) => {
                      const original = cache.readQuery({query})
                      const index = original.me.annual_leave.findIndex(annualLeave => annualLeave.id === updateAnnualLeave.id)
                      cache.writeQuery({
                          query,
                          data: {
                            me: {
                              ...original.me,
                              annual_leave: [
                                ...original.me.annual_leave.slice(0, index),
                                updateAnnualLeave,
                                ...original.me.annual_leave.slice(index+1),
                              ]
                            }
                          }
                      })
                    }}
                  >
                    {(updateAnnualLeaveFunc, mut) => (
                      <Query query={annualLeaveRecordQuery} variables={{id: editAnnualLeaveID}} fetchPolicy="network-only">
                        {(alr) => {
                          console.log(alr)
                          let data = {
                            id: '',
                            start_date: '',
                            start_of_day: '1',
                            end_date: '',
                            end_of_day: '1',
                          }
          
                          if(!loading && alr.data && alr.data.annual_leave_record){
                            data = {
                              id: alr.data.annual_leave_record.id,
                              start_date: moment(alr.data.annual_leave_record.start_date).format('YYYY-MM-DD'),
                              start_of_day: (alr.data.annual_leave_record.start_of_day) ? '1' : '0',
                              end_date: moment(alr.data.annual_leave_record.end_date).format('YYYY-MM-DD'),
                              end_of_day: (alr.data.annual_leave_record.end_of_day) ? '1' : '0',
                            }
                          }
          
                          return (
                            <AnnualLeaveInput
                              title="Edit Annual Leave"
                              isOpen={showEdit}
                              toggle={toggleEdit}
                              loading={alr.loading}
                              {...data}
                              saving={mut.loading}
                              onChange={({key, value}) => {
                                localMutationFunc({
                                  variables: {
                                    data: 
                                      {
                                        ...data, 
                                        [key]: value
                                      }
                                  }
                                })
                              }}
                              onSave={({id, start_date, start_of_day, end_date, end_of_day}) => {
                                console.log(id, start_date, start_of_day, end_date, end_of_day)
                                updateAnnualLeaveFunc({
                                  variables: {
                                    data: {
                                      id,
                                      start_date,
                                      start_of_day: !!parseInt(start_of_day),
                                      end_date,
                                      end_of_day: !!parseInt(end_of_day)
                                    }
                                  }
                                })
                                  .then(res => {
                                    toast.success('Annual Leave Edited', {autoClose: 2000})
                                    resetEdit()
                                  })
                                  .catch(e => toast.error(e.message, {autoClose: false}))
                
                              }}
                            />
                          )
                        }
                      }
                      </Query>
                    )}
                  </Mutation>
                )}
              </Mutation>
              
            }
          </div>
        )}
        
      </Mutation>
      
    )
  }
}